import React from 'react';

/** An inline text input with no visible input chrome. */
const FlushInput = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(({ className, ...props }, ref) => (
  <input
    ref={ref}
    className={`border-none bg-transparent px-0 shadow-none outline-none focus-visible:border-none focus-visible:ring-0 focus-visible:ring-offset-0 ${className ?? ''}`}
    {...props}
  />
));

FlushInput.displayName = 'FlushInput';

export default FlushInput;
